export default __webpack_public_path__ + "static/media/ic_close_modal.161840a2.svg";